import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets scroll position to the top whenever the route (path or search)
 * changes. Mount this inside <BrowserRouter>. Honours in-page hash anchors
 * (e.g. /about#postcodes) by skipping the reset when a hash is present.
 */
export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();
  useEffect(() => {
    if (hash) return; // let the browser handle #anchor scrolling
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, search, hash]);
  return null;
}
